module.exports = __webpack_public_path__ + "img/bunny.6612265f.svg";